export default __webpack_public_path__ + "static/media/IndigenousPeoples_fr.9036c038.svg";